module.exports = __webpack_public_path__ + "static/media/21ECLAC28.46b3400f.jpg";